import React from 'react';
import { motion } from 'framer-motion';
import { Logo } from './Logo';
export const Footer = () => {
  return <footer className="bg-black py-16 px-4 sm:px-6 lg:px-8 border-t border-brand-red/20" data-id="element-59">
      <div className="max-w-6xl mx-auto" data-id="element-60">
        <div className="text-center mb-12" data-id="element-61">
          <Logo className="mx-auto mb-6" data-id="element-62" />
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="max-w-3xl mx-auto italic text-lg text-white/70" data-id="element-63">
            <p className="mb-6" data-id="element-64">
              We believe praise is worship. Every voice is a gift from God.
              <br data-id="element-65" />
              Singing is prayer. This is not performance, it's communion with
              the Lord.
              <br data-id="element-66" />
              Lift your voice. Enter His presence.
            </p>
          </motion.div>
        </div>
        <div className="border-t border-brand-red/20 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-67">
          <p className="text-white/50 mb-4 md:mb-0" data-id="element-68">
            &copy; {new Date().getFullYear()} Praise Karaoke. All rights
            reserved.
          </p>
          <div className="flex space-x-6" data-id="element-69">
            {['About', 'Experience', 'Community', 'Visit', 'Privacy', 'Terms'].map((item, index) => <a key={index} href="#" className="text-white/50 hover:text-brand-red transition-colors" data-id="element-70">
                {item}
              </a>)}
          </div>
        </div>
      </div>
    </footer>;
};